// extracted by mini-css-extract-plugin
module.exports = {"sun":"styles_sun__ZUJI_","loading-wheel":"styles_loading-wheel__47Nfn"};